import { render, staticRenderFns } from "./shopRiskDlg.vue?vue&type=template&id=5e37e39d&scoped=true"
import script from "./shopRiskDlg.vue?vue&type=script&lang=js"
export * from "./shopRiskDlg.vue?vue&type=script&lang=js"
import style0 from "./shopRiskDlg.vue?vue&type=style&index=0&id=5e37e39d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e37e39d",
  null
  
)

export default component.exports